// src/contexts/TwitterContext.js
import React, { createContext, useContext, useCallback } from 'react';
import { twitterService } from '../services/twitter';
import { handleTwitterError } from '../utils/twitterUtils';

const TwitterContext = createContext(null);

export const TwitterProvider = ({ children }) => {
  const fetchTwitterUser = useCallback(async (username) => {
    try {
      console.log('Fetching Twitter user:', username);
      const userData = await twitterService.getUserIdByUsername(username);
      const followerData = await twitterService.getFollowersByUserId(userData.id);
      
      return {
        ...userData,
        followers: followerData.followerCount
      };
    } catch (error) {
      console.error('Twitter API error:', error);
      throw handleTwitterError(error);
    }
  }, []);

  const value = {
    fetchTwitterUser
  };

  return (
    <TwitterContext.Provider value={value}>
      {children}
    </TwitterContext.Provider>
  );
};

export const useTwitter = () => {
  const context = useContext(TwitterContext);
  if (!context) {
    throw new Error('useTwitter must be used within a TwitterProvider');
  }
  return context;
};